import { c as a } from "../../vendor-BBkOA5CU.js";
import { getSpacingClasses as d } from "../../utils/getSpacingClasses/index.js";
import "react/jsx-runtime";
import "react";
import '../../assets/index13.css';const i = "V6JZKq_baseButton", p = "V6JZKq_destructive", u = "V6JZKq_ghost", q = "V6JZKq_md", y = "V6JZKq_primary", J = "V6JZKq_secondary", K = "V6JZKq_sm", t = {
  baseButton: i,
  destructive: p,
  ghost: u,
  md: q,
  primary: y,
  secondary: J,
  sm: K
}, B = ({
  size: s,
  variant: o,
  m: r,
  mt: c,
  mr: e,
  mb: n,
  ml: m
}) => a(
  t.baseButton,
  s ? t[s] : void 0,
  o ? t[o] : void 0,
  d({ m: r, mt: c, mr: e, mb: n, ml: m })
);
export {
  B as getButtonStyles
};
//# sourceMappingURL=index.js.map
